import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Brand } from "../Brand";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import partnerApi from "../../lib/partnerApi";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function PartnerLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ partner_id: "", api_key: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await partnerApi.post("/partner/auth/login", form);
      localStorage.setItem("xch_partner_token", r.data.token);
      localStorage.setItem("xch_partner", JSON.stringify(r.data.partner));
      toast.success("Welcome back");
      navigate("/partner/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div
      className="min-h-screen xch-app-bg flex items-start sm:items-center justify-center p-4 overflow-y-auto"
      style={{ minHeight: "100dvh", paddingBottom: "max(env(safe-area-inset-bottom), 4rem)" }}
    >
      <div className="xch-card w-full max-w-md p-8 space-y-5" data-testid="partner-login-card">
        <div className="text-center space-y-2">
          <div className="flex justify-center"><Brand size={32} /></div>
          <div className="xch-eyebrow"><KeyRound className="w-3 h-3" /> Partner portal</div>
          <h1 className="xch-headline text-3xl">Sign in</h1>
          <p className="text-sm text-muted-foreground">Manage your embed, see your revenue, fire test webhooks.</p>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Partner ID</Label>
            <Input required value={form.partner_id} onChange={(e) => setForm({ ...form, partner_id: e.target.value })}
                   placeholder="e.g. demo_partner" className="rounded-xl font-mono" data-testid="partner-id-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">API Key</Label>
            <Input required type="password" value={form.api_key} onChange={(e) => setForm({ ...form, api_key: e.target.value })}
                   placeholder="xch_pk_…" className="rounded-xl font-mono" data-testid="partner-key-input" />
          </div>
          <Button type="submit" disabled={loading}
                  className="w-full bg-primary hover:bg-primary/90 text-white rounded-xl h-12 font-display font-semibold"
                  data-testid="partner-login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <div className="text-xs text-muted-foreground text-center">
          Test partner: <strong className="font-mono">demo_partner / partner_key_demo</strong>
        </div>
      </div>
    </div>
  );
}
